<div class="flex flex-col w-full gap-1">
    <label [attr.for]="id" class="font-bold text-black">{{ label }}</label>
    <input
        [ngClass]="{ invalid: campoInvalido }"
        [type]="type"
        [id]="id"
        [placeholder]="placeholder"
        [readOnly]="!!isReadOnly"
        [(ngModel)]="value"
        (blur)="aplicarMascara($event)"
        (change)="change($event)"
        autocomplete="off"
        pInputText
        class="bg-white h-8! flex-1 border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300 rounded-lg"
    />
</div>
